import React, { useState } from 'react';
import { ConnectionDataModal } from '../ConnectionDataModal/ConnectionDataModal';
import { Button } from '../common/Button';
import { useTranslation } from 'react-i18next';

export const GetConnectionData: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation('Dashboard');

  return (
    <>
      <Button 
        onClick={() => setIsModalOpen(true)} 
        size="sm" 
        className="text-xs sm:text-sm px-2 sm:px-3 py-1.5 sm:py-2 whitespace-nowrap"
      >
        <span className="hidden sm:inline">{t('actions.getConnectionData')}</span>
        <span className="sm:hidden">{t('actions.getData')}</span>
      </Button>

      <ConnectionDataModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

